import { useIntl } from '../../hooks';
import { SignalType } from '../../types';
import { renderSignalTypeIcon } from '../SignalTypeIcon.js';

export type SignalTypeSelectorProps = {
  value: SignalType;
  onChange: (value: SignalType) => void;
  disabled: boolean;
  /**
   * Radio-group name. Distinct per form: two forms rendering this with the same name put their
   * radios in one native group, so selecting a type in one clears the other's selection.
   */
  name: string;
  /** Names the group itself. Each radio labels only its own signal type, leaving the set unnamed. */
  groupLabel: string;
};

export function SignalTypeSelector({
  value,
  onChange,
  disabled,
  name,
  groupLabel,
}: SignalTypeSelectorProps) {
  const intl = useIntl();

  return (
    <div className="flex h-10 gap-1" role="radiogroup" aria-label={groupLabel}>
      {Object.values(SignalType).map((type) => {
        const isSelected = value === type;
        const label = intl.formatMessage({
          id: `broadbandSuppressionsDialog.form.type.${type}`,
        });

        return (
          <label
            key={type}
            className={`flex h-10 w-10 cursor-pointer select-none items-center justify-center rounded-md border transition-colors ${
              isSelected
                ? 'border-black bg-background'
                : 'border-border bg-background-light hover:bg-background-dark'
            }`}
            title={label}
          >
            <input
              type="radio"
              name={name}
              value={type}
              checked={isSelected}
              disabled={disabled}
              aria-label={label}
              onChange={() => onChange(type)}
              className="sr-only"
            />
            {renderSignalTypeIcon(type, label)}
          </label>
        );
      })}
    </div>
  );
}
